<template>
  <v-app class="main">
    <v-main>
      <nav class="navbar navbar-expand-lg site-navbar navbar-light bg-light" id="pb-navbar">
            <div class="container">
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample09" aria-controls="navbarsExample09" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse justify-content-md-center" id="navbarsExample09">
                    <ul class="navbar-nav">
                        <router-link to='/' tag="li" active-class="nav-item"><a class="nav-link" href="#section-home"><span :class="{ 'active': $route.path == '/' }">Home</span></a></router-link>
                        <router-link to='/resume' tag="li" active-class="nav-item"><a class="nav-link" href="#section-resume"><span :class="{ 'active': $route.path == '/resume' }">Resume</span></a></router-link>
                        <router-link to='/projects' tag="li" active-class="nav-item"><a class="nav-link" href="#section-projects"><span :class="{ 'active': $route.path == '/projects' }">Projects</span></a></router-link>
                        <router-link to='/publications' tag="li" active-class="nav-item"><a class="nav-link" href="#section-projects"><span :class="{ 'active': $route.path == '/publications' }">Publications</span></a></router-link>
                        <router-link to='/blogs' tag="li" active-class="nav-item"><a class="nav-link" href="#section-blog"><span :class="{ 'active': $route.path == '/blogs' }">Blogs</span></a></router-link>
                    </ul>
                </div>
            </div>
        </nav>
      <router-view></router-view>
      <Footer />
      <!-- <Main/> -->
    </v-main>
  </v-app>
</template>

<script>
// import Main from './components/Main';
// import Navbar from './Navbar';
import Footer from './Footer';
export default {
  name: 'App',

  components: {
    // Main,
    // Navbar,
    Footer
  },

  data: () => ({
    //
  }),
};
</script>
<style>
.main{
  background: #222222 !important;
}
.nav-item{
		font-size: 14px;
		font-weight: 200;
		letter-spacing: .1em;
		position: relative;
		text-transform: uppercase;
		letter-spacing: .2em;
        
	}
    .navbar-nav > li > a {padding: 15px 20px !important;}
    .active{
        color: #FFB20A !important;
    }
</style>